import React from 'react';
import cn from 'classnames';
import { Dropdown, Icon } from 'UI';
import stl from './FilterOperator.css';
function FilterOperator(props) {
    var options = props.options, value = props.value, onChange = props.onChange, _a = props.className, className = _a === void 0 ? '' : _a;
    return (React.createElement(Dropdown, { className: cn(stl.operatorDropdown, className, 'hover:bg-gray-light-shade'), options: options, name: "operator", value: value, onChange: onChange, placeholder: "Select operator", icon: React.createElement(Icon, { className: "ml-5", name: "chevron-down", size: "12" }) }));
}
export default FilterOperator;
